import React from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

export default function AdvancedOptimiseAnalysingDialog({ open }) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{
        sx: { borderRadius: 2, minWidth: 320 },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            py: 3,
            px: 2,
            gap: 2,
          }}
        >
          <AutoFixHighIcon color="primary" sx={{ fontSize: 40 }} />
          <CircularProgress size={44} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            AI Analysing
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Optimising your resume for this job. Please wait...
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
